function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("mask", {
  id: "steam-rect"
}, React.createElement("rect", {
  x: 21.4,
  y: 22,
  width: 16.6,
  height: 13.3,
  fill: "#000000"
}), React.createElement("path", {
  className: "o-kitchen-steam o-svg-dark",
  fill: "#ffffff",
  d: "M28.7,19.8v0.5c0,0.5-0.3,1.9-1.1,2.7c-1.9,1.9-2.1,3.2-2.1,4.8c0,1.6,0.3,2.9,2.1,4.8c0.8,0.8,1.1,2.1,1.1,2.7 v0.5c0,0.5-0.3,1.9-1.1,2.7c-1.9,1.9-2.1,3.2-2.1,4.8c0,1.6,0.3,2.9,2.1,4.8c0.8,0.8,1.1,2.1,1.1,2.7v0.5c0,0.5-0.3,1.9-1.1,2.7 c-1.9,1.9-2.1,3.2-2.1,4.8c0,1.6,0.3,2.9,2.1,4.8c0.8,0.8,1.1,2.1,1.1,2.7v0.5c0,0.5-0.3,1.9-1.1,2.7c-1.9,1.9-2.1,3.2-2.1,4.8 s0.3,2.9,2.1,4.8c0.8,0.8,1.1,2.1,1.1,2.7v0.5c0,0.5-0.3,1.9-1.1,2.7c-1.9,1.9-2.1,3.2-2.1,4.8c0,1.6,0.3,2.9,2.1,4.8 c0.8,0.8,1.1,2.1,1.1,2.7v0.5c0,0.5-0.3,1.9-1.1,2.7c-1.9,1.9-2.1,3.2-2.1,4.8c0,1.6,0.3,2.9,2.1,4.8c0.5,0.5,0.8,1.3,1.1,1.9 c0,0.3,0,0.3,0,0.5v0.5c0,0.5-0.3,1.9-1.1,2.7c-1.9,1.9-2.1,3.2-2.1,4.8s0.3,2.9,2.1,4.8c0.8,0.8,1.1,2.1,1.1,2.7v0.5 c0,0.5-0.3,1.9-1.1,2.7c-1.9,1.9-2.1,3.2-2.1,4.8c0,1.6,0.3,2.9,2.1,4.8c0.8,0.8,1.1,2.1,1.1,2.7v0.5c0,0.5-0.3,1.9-1.1,2.7 c-1.9,1.9-2.1,3.2-2.1,4.8c0,1.6,0.3,2.9,2.1,4.8c0.8,0.8,1.1,2.1,1.1,2.7v0.5c0,0.5-0.3,1.9-1.1,2.7c-1.9,1.9-2.1,3.2-2.1,4.8 s0.3,2.9,2.1,4.8c0.8,0.8,1.1,2.1,1.1,2.7v0.5c0,0.5-0.3,1.9-1.1,2.7c-1.9,1.9-2.1,3.2-2.1,4.8c0,1.6,0.3,2.9,2.1,4.8 c0.8,0.8,1.1,2.1,1.1,2.7v0.5c0,0.5-0.3,1.9-1.1,2.7c-1.9,1.9-2.1,3.2-2.1,4.8c0,1.6,0.3,2.9,2.1,4.8c0.5,0.5,0.8,1.6,1.1,2.1 c0.3,0.8,1.1,1.3,1.9,1.3c0.8-0.3,1.3-1.1,1.3-1.9c-0.3-1.1-0.5-2.7-1.9-3.7c-1.3-1.3-1.3-1.9-1.3-2.7c0-0.5,0-1.3,1.3-2.7 c1.6-1.6,1.9-3.7,1.9-4.8v-0.8c0-1.1-0.5-3.2-1.9-4.8c-1.3-1.3-1.3-1.9-1.3-2.7c0-0.5,0-1.3,1.3-2.7c1.6-1.6,1.9-3.7,1.9-4.8v-0.8 c0-1.1-0.5-3.2-1.9-4.8c-1.3-1.3-1.3-1.9-1.3-2.7c0-0.5,0-1.3,1.3-2.7c1.6-1.6,1.9-3.7,1.9-4.8v-0.8c0-1.1-0.5-3.2-1.9-4.8 c-1.3-1.3-1.3-1.9-1.3-2.7c0-0.5,0-1.3,1.3-2.7c1.6-1.6,1.9-3.7,1.9-4.8l0,0l0,0l0,0V142c0-1.1-0.5-3.2-1.9-4.8 c-1.3-1.3-1.3-1.9-1.3-2.7c0-0.5,0-1.3,1.3-2.7c1.6-1.6,1.9-3.7,1.9-4.8v-0.8c0-1.1-0.5-3.2-1.9-4.8c-1.3-1.3-1.3-1.9-1.3-2.7 c0-0.5,0-1.3,1.3-2.7c1.6-1.6,1.9-3.7,1.9-4.8v-0.5l0,0c0-0.3,0-0.5,0-0.8c-0.3-1.1-0.5-2.7-1.9-3.7c-1.3-1.3-1.3-1.9-1.3-2.7 c0-0.5,0-1.3,1.3-2.7c1.6-1.6,1.9-3.7,1.9-4.8v-0.8c0-1.1-0.5-3.2-1.9-4.8c-1.3-1.3-1.3-1.9-1.3-2.7c0-0.5,0-1.3,1.3-2.7 c1.6-1.6,1.9-3.7,1.9-4.8v-0.8c0-1.1-0.5-3.2-1.9-4.8c-1.3-1.3-1.3-1.9-1.3-2.7c0-0.5,0-1.3,1.3-2.7c1.6-1.6,1.9-3.7,1.9-4.8V64 c0-1.1-0.5-3.2-1.9-4.8c-1.3-1.3-1.3-1.9-1.3-2.7c0-0.5,0-1.3,1.3-2.7c1.6-1.6,1.9-3.7,1.9-4.8l0,0l0,0l0,0v-0.8 c0-1.1-0.5-3.2-1.9-4.8c-1.3-1.3-1.3-1.9-1.3-2.7c0-0.5,0-1.3,1.3-2.7c1.6-1.6,1.9-3.7,1.9-4.8v-0.8c0-1.1-0.5-3.2-1.9-4.8 c-1.3-1.3-1.3-1.9-1.3-2.7c0-0.5,0-1.3,1.3-2.7c1.6-1.6,1.9-3.7,1.9-4.8v-0.5c0-0.8-0.8-1.6-1.6-1.6S28.7,19.1,28.7,19.8z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "o-svg-dark",
  d: "M104.4,11.8H77c-0.5,0-0.9,0.4-0.9,0.9v28.6H43.2h-6.8h-4.3h-6.8H0.9C0.4,41.2,0,41.6,0,42.1v28.5c0,0.5,0.4,0.9,0.9,0.9 h75.6c0.1,0.1,0.3,0.1,0.4,0.1h27.4c0.5,0,0.9-0.4,0.9-0.9v-58C105.3,12.2,104.9,11.8,104.4,11.8z M103.5,13.6v16.9H77.9V13.6H103.5 z M76,56.4H47.5V43H76V56.4z M45.7,49.1H23.2v-6h22.5V49.1z M23.2,50.9h22.5v18.9H23.2V50.9z M1.8,43h19.6v26.7H1.8V43z M47.5,69.7 V58.2H76v11.6H47.5V69.7z M77.9,69.9V32.3h25.6v37.6C103.5,69.9,77.9,69.9,77.9,69.9z M35.2,36.5h-0.9v-0.3c0-0.4-0.3-0.8-0.8-0.8 h-9.4c-0.4,0-0.8,0.3-0.8,0.8v0.3h-1c-0.4,0-0.8,0.3-0.8,0.8S22,38,22.4,38h1v2.7c0,0.4,0.3,0.8,0.8,0.8h9.4c0.4,0,0.8-0.3,0.8-0.8 V38h0.9c0.4,0,0.8-0.3,0.8-0.8S35.6,36.5,35.2,36.5z M32.8,39.9h-7.9v-3h7.9V39.9z M21.7,22h25.4c0.5,0,0.9-0.4,0.9-0.9v-3.5 c0-0.5-0.4-0.9-0.9-0.9h-6V1.1c0-0.5-0.4-0.9-0.9-0.9H29c-0.5,0-0.9,0.4-0.9,0.9v15.6h-6.4c-0.5,0-0.9,0.4-0.9,0.9v3.5 C20.8,21.6,21.2,22,21.7,22z M29.9,2h9.4v14.7h-9.4V2z M22.6,18.5H29h11.2h5.9v1.7H22.6V18.5z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "o-svg-dark",
  d: "M18.7,52.3c-0.5,0-0.9,0.4-0.9,0.9v7c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-7C19.6,52.7,19.2,52.3,18.7,52.3z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "o-svg-dark",
  d: "M56.6,50.6h9.3c0.5,0,0.9-0.4,0.9-0.9s-0.4-0.9-0.9-0.9h-9.3c-0.5,0-0.9,0.4-0.9,0.9S56.1,50.6,56.6,50.6z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "o-svg-dark",
  d: "M66.2,62.9h-9.3c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9h9.3c0.5,0,0.9-0.4,0.9-0.9C67.1,63.3,66.7,62.9,66.2,62.9z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "o-svg-dark",
  d: "M41.6,53.4H26.8c-0.5,0-0.9,0.4-0.9,0.9v10.3c0,0.5,0.4,0.9,0.9,0.9h14.9c0.5,0,0.9-0.4,0.9-0.9V54.3 C42.5,53.8,42.1,53.4,41.6,53.4z M40.7,63.6h-13v-8.5h13.1L40.7,63.6L40.7,63.6z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "o-svg-dark",
  d: "M82.3,27.6c0.5,0,0.9-0.4,0.9-0.9v-7.5c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9v7.4C81.4,27.2,81.8,27.6,82.3,27.6z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "o-svg-dark",
  d: "M81.9,36.2c-0.5,0-0.9,0.4-0.9,0.9v7.4c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-7.4C82.8,36.6,82.4,36.2,81.9,36.2z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  id: "masked-steam-rect",
  mask: "url(#steam-rect)"
}, React.createElement("rect", {
  className: "o-svg-dark",
  x: 21.4,
  y: 22,
  width: 16.6,
  height: 13.3
}));

var SvgKitchen = function SvgKitchen(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106 72.1",
    style: {
      enableBackground: "new 0 0 106 72.1"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

export default __webpack_public_path__ + "static/media/kitchen.b38bc1bf.svg";
export { SvgKitchen as ReactComponent };